export default __webpack_public_path__ + "static/media/c_3.424f1b9d.svg";